'use strict';

import { dataMember, required, typedArray } from 'santee-dcts';

export class AdminSponsor {

    @dataMember()
    @required()
    public sponsorId: string;

    @dataMember()
    public sponsorTitle: string;
}

export class AdminSponsorReadModel {
    @dataMember()
    @required()
    @typedArray(AdminSponsor)
    public sponsors: AdminSponsor[];
}